import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';

import type { Swiper as SwiperType } from 'swiper';
import fetchData from 'Utilis/request';
import {Loader} from './Index';

interface TickerItem {
  id: string;
  name: string;
  date_time: string;
  post_slug: string;
  post_title: string;
  created: string;
}

interface NewsTickerProps {
  darkMode?: boolean;
}
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const Breaking: React.FC<NewsTickerProps> = ({ darkMode = false }) => {
  const [tickers, setTickers] = useState([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const swiperRef = useRef<{ swiper: SwiperType | null }>({ swiper: null });

  useEffect(() => {
    const fetchTickerData = async () => {
      try {
        setLoading(true);
        setError(null);       
         const response = await fetchData.getResult(`${API_BASE_URL}getArticleLatest.php`);
        // console.log(response?.articles, " response EE");
        if (response && Array.isArray(response?.articles)) {
          setTickers(response?.articles);
          if (swiperRef.current.swiper) {
            swiperRef.current.swiper.autoplay.start();
            swiperRef.current.swiper.update();
          }
        } else {
          setError("Invalid ticker data format received.");
          setTickers([]);
          if (swiperRef.current.swiper) {
            swiperRef.current.swiper.autoplay.stop();
          }
        }
      } catch (e) {
        console.error("Failed to fetch ticker data:", e);
        setError(e instanceof Error ? e.message : "An unknown error occurred while fetching tickers.");
        setTickers([]);
        if (swiperRef.current.swiper) {
          swiperRef.current.swiper.autoplay.stop();
        }
      } finally {
        setLoading(false);
      }
    };

    fetchTickerData();
  }, []);

  const handleMouseEnter = () => {
    if (swiperRef.current.swiper && swiperRef.current.swiper.autoplay) {
      swiperRef.current.swiper.autoplay.stop();
    }
  };

  const handleMouseLeave = () => {
    if (swiperRef.current.swiper && swiperRef.current.swiper.autoplay) {
      if (tickers.length > 0) {
        swiperRef.current.swiper.autoplay.start();
      }
    }
  };

  const handleClick = (id: string) => {
    navigate(`/news/${id}`);
  };

  const baseContainerClasses = `
    relative overflow-hidden h-10x flex items-center
    ${darkMode ? 'text-white' : 'text-gray-800'}`;

  if (loading) {
    return (
      <div className={`${baseContainerClasses} justify-center px-3`}>
        <Loader darkMode={darkMode}/>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`${baseContainerClasses} justify-center px-3 ${darkMode ? 'text-red-400' : 'text-red-600'}`}>
        Error loading breaking news: {error}
      </div>
    );
  }

  if (tickers.length === 0) {
    return (
      <div className={`${baseContainerClasses} justify-center px-3 ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
        No breaking news available.
      </div>
    );
  }

  return (
    <div
      className={`${baseContainerClasses}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>
       {/* <div className="flex-shrink-0 flex items-center h-full xw-[150px] x!min-w-[150px]">
        <div className="bg-red-600 text-white rounded-l-lg font-semibold py-1 px-4 text-sm h-full flex items-center justify-center">
          LIVE NEWS
        </div>     
      </div>  */}
      <div className="px-3x py-2 flex-grow h-full overflow-hidden min-w-0" style={{ minWidth: '0' }}>
        <Swiper
          modules={[Autoplay]}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 9993000,
            disableOnInteraction: false,
          }}
          speed={800}
          spaceBetween={30} 
          allowTouchMove={true}
          className="mySwiper h-full w-full"
          onSwiper={(swiper: SwiperType) => {
            swiperRef.current.swiper = swiper;
            if (tickers.length > 0) {
              swiper.autoplay.start();
            }
          }}>
          {tickers.map((ticker: TickerItem) => (
            <SwiperSlide
              key={ticker.id}
              style={{alignContent:'space-evenly'}}
              className="flex items-center justify-start" // Added h-full here
            >
              <div
                className="flex items-center text-sm cursor-pointer hover:text-orange-400 whitespace-nowrapx overflow-hidden text-ellipsis px-2"
                onClick={() => handleClick(ticker?.post_slug)}
                aria-label={`Read more about ${ticker?.post_title}`}
              >
               <span className="w-[10px] h-[10px] bg-red-500 rounded-full ml-0 animate-pulse" style={{minWidth:'10px'}}></span>
               <span className=''>{ticker?.post_title}</span>
               {/* <span className="font-bold ml-2 text-gray-400">{ticker?.created}</span> */}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Breaking;